import classNames from 'classnames';
import Button from 'components/Button/Button';
import Text from 'components/Text/Text';
import BaseMccField from './components/BaseMccField';
import MccCard from './components/MccCard';
import {
	RestaurantFullInfoContext,
	IRestaurantFullInfoContext,
} from 'modules/CustomersAndRestaurants/Restaurants/RestaurantFullInfo/restaurantFullInfoState/restaurantFullInfoContext';
import React, { useContext, useState } from 'react';
import breadcrumbs from 'assets/img/breadcrumbs.svg';
import style from './Mcc.module.scss';

const Mcc: React.FC = () => {
	const { restaurantForFullInfo } = useContext<IRestaurantFullInfoContext>(RestaurantFullInfoContext);
	const [isShowAdditionalMccCards, setShowAdditionalMccCards] = useState<boolean>(false);
	const expandIconClasses = classNames(style.expandIcon, { [style.rotated]: isShowAdditionalMccCards });

	const toggleShowAdditionalMccCards = () => {
		setShowAdditionalMccCards((prevState) => !prevState);
	};

	const mccCards = restaurantForFullInfo?.merchantCategoryCode?.mccCards;
	const mccCardsCount = mccCards?.length;

	const disableExpandButton = () => {
		if (mccCardsCount) {
			return mccCardsCount <= 1;
		}
		return true;
	};

	return (
		<div className={style.container}>
			<Button
				className={style.expandButton}
				theme="secondaryPurple"
				onClick={toggleShowAdditionalMccCards}
				disabled={disableExpandButton()}
				icon={
					<svg className={expandIconClasses}>
						<use xlinkHref={`${breadcrumbs}#rightAngleArrow`} />
					</svg>
				}>
				<Text
					translationNameSpace="form"
					translationKey={isShowAdditionalMccCards ? 'hideAddedFieldsButton' : 'expandAddedFieldsButton'}
					asFragment={true}
				/>
			</Button>
			<BaseMccField />
			<MccCard cardInfo={mccCards ? mccCards[0] : undefined} />
			{isShowAdditionalMccCards && (
				<div className={style.additionalMccCards}>
					{mccCards?.slice(1).map((el) => (
						<MccCard key={el.brand} cardInfo={el} />
					))}
				</div>
			)}
		</div>
	);
};

export default Mcc;
